<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Publicações: Ações
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Ações na publicação:
        strong  vincular
        |  /
        strong  desvincular
        |  documentos,
        strong  encerrar
        |  ou
        strong  cancelar
        | .

      .toast.toast-primary
        | Vincular/desvincular exigem as permissões correspondentes em
        strong  Publicações → Publicações de documentos
        |  (e documentos da publicação). Encerrar/Cancelar exigem
        strong  Encerrar
        |  /
        strong  Cancelar
        | .

      h5.h5 1. Abrir a publicação
      ol
        li Em
          strong  Doc → Publicações
          | , abra a publicação com
          strong  Exibir
          | .
      figure.manual-figure
        img(:src="imgShow" alt="Publicação com documentos e ações")

      h5.h5 2. Vincular e desvincular
      ol
        li Clique em
          strong  + Vincular documentos
          |  para associar documentos à publicação.
        li No documento vinculado, use a
          strong  lixeira
          |  para desvincular.

      h5.h5 3. Encerrar ou Cancelar
      figure.manual-figure
        img(:src="imgAcoes" alt="Confirmação Encerrar publicação")
      ol
        li
          strong Encerrar
          |  — confirma o encerramento; documentos vinculados recebem ciência
          |  como diário oficial. Ação irreversível.
        li
          strong Cancelar
          |  — cancela a publicação (quando permitido).
        li Leia o aviso do modal e confirme apenas se tiver certeza.
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgShow: require("@/assets/manuais/19b-doc-publicacoes-show.png"),
      imgAcoes: require("@/assets/manuais/19c-doc-publicacoes-acoes.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
